import axiosInstance from '../../axios.instance';
import {history} from '../../helpers/history';
import {requestHelper} from '../helpers';
import { maestroenv } from '../../helpers/maestroenv';
import {SharedUser} from "../definitions";

export const userService = {
  activateUserById,
  checkSharedUserByEmail,
  deactivateUserById,
  login,
  oauthLogin,
  oauthLogout,
  getOAuthUser,
  lockUserById,
  loginWithRole,
  loginAsSharedUser,
  logout,
  register,
  getUserProfile,
  getSharedUserProfile,
  changePassword,
  getAll,
  getAdditionalUserDetails,
  getAllSharedUsers,
  getAllSharedUsersOfDocument,
  getAllUsersOfCompany,
  getUserPrivilegesOfCompany,
  getUserRolePrivilegesOfCompany,
  getUserQuestionsOfId,
  getValidRolesToManage,
  getById,
  refreshToken,
  sendEmailToUser,
  addUser,
  addSharedUser,
  removeSharedUsers,
  removeSharedUsersOfDocument,
  removeSharedUserAndDocuments,
  unlockUserById,
  updateUserDetails,
  updateUserProfile,
  updateSharedUserDetails,
  updateSharedUserKeyInfo,
  updateSharedUserPasswordInfo
};

function login(email, password, envCheckLicense) {
  return axiosInstance.post('/auth/login', {email, password, envCheckLicense})
    .then(response => {
      localStorage.setItem('token', JSON.stringify(response.data.data))
      return response.data;
    }).catch(function (error) {
      localStorage.removeItem('token');
      return authErrorFunction(error, true);
    });
}

function oauthLogin(url) {
  console.log(url);
  return axiosInstance.get(url)
    .then(
      response => {
        if (!response.data && response.request.responseURL) {
          window.location.href = response.request.responseURL;
        } else {
          window.location.href=url;
        }
      })
    .catch(authErrorFunction);
}

function oauthLogout(user) {
  return logoutProcess(user);

  async function logoutProcess(userApi, userOauth){
    let errors = [];
    let logoutApiResponse = await logoutApi(userApi).catch(error => errors.push(error));
    let logoutOauthResponse = await logoutOauth().catch(error => errors.push(error));

    switch (errors.length){
      case 0:
        return Promise.resolve({logoutApi: logoutApiResponse, logoutOauth: logoutOauthResponse});
      case 1:
        return Promise.reject(errors[0]);
      default:
        return Promise.reject(errors);
    }
  }

  function logoutApi(user) {
    return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/auth/userLogout`, JSON.stringify(user))
      .catch(error => authErrorFunction(error, true, true));
  }

  function logoutOauth() {
    return axiosInstance.get(maestroenv.REACT_APP_OAUTH_SIGN_OUT_URL, {withCredentials: true})
      .catch(error => authErrorFunction(error, true, true))
  }
}

function getOAuthUser(envCheckLicense) {
  return axiosInstance.post('/auth/user', {envCheckLicense})
    .then(response => {
      localStorage.setItem('token', JSON.stringify(response.data.data))
      return response.data;
    }).catch(function (error) {
      localStorage.removeItem('token');
      history.push('/');
      return authErrorFunction(error, true);
    });
}

function loginWithRole(role) {
  let envCheckLicense = maestroenv.REACT_APP_CHECK_LICENSE === '1' || maestroenv.REACT_APP_CHECK_LICENSE === 'true' ;
  return axiosInstance.post('/auth/loginWithRole', {role, envCheckLicense})
    .then(response => {
      localStorage.setItem('token', JSON.stringify(response.data.data))
      return response.data;
    }).catch(function (error) {
      localStorage.removeItem('token');
      return authErrorFunction(error, true);
    });
}

function loginAsSharedUser(email, accessKey, envCheckLicense) {
  return axiosInstance.post('/auth/sharedLogin', {email, accessKey, envCheckLicense})
    .then(response => {
      localStorage.setItem('token', JSON.stringify(response.data.data))
      return response.data;
    }).catch(function (error) {
      localStorage.removeItem('token');
      return authErrorFunction(error, false);
    });
}

function refreshToken() {
  let envCheckLicense = maestroenv.REACT_APP_CHECK_LICENSE === '1' || maestroenv.REACT_APP_CHECK_LICENSE === 'true' ;
  return axiosInstance.post('/auth/refresh_token', {envCheckLicense},{
    withCredentials: false
  }).then(({data}) => {
    if (data && data.data) {
      localStorage.setItem('token', JSON.stringify(data.data));
      return data;
    } else {
      localStorage.removeItem('token');
      return Promise.reject(requestHelper.handleErrorResponse("Authorization Refresh Failed"));
    }
  }).catch(function (error) {
    return Promise.reject(requestHelper.handleErrorResponse(error));
  });
}

function logout() {
  return axiosInstance.get(maestroenv.REACT_APP_OAUTH_SIGN_OUT_URL, {withCredentials: true})
    .then(response => {
      return response;
    })
    .catch(error => authErrorFunction(error, true, true));
}

function getAll() {
  return axiosInstance.get('/users/')
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getAllUsersOfCompany(companyId) {
  return axiosInstance.get(`/users/bycompany/${companyId}`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getUserQuestionsOfId(userId) {
  return axiosInstance.get(`/user/${userId}/questions/`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getUserPrivilegesOfCompany(userSearch) {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/users/privileges`, JSON.stringify(userSearch))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getUserRolePrivilegesOfCompany(userSearch) {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/users/roleprivileges`, JSON.stringify(userSearch))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getAdditionalUserDetails(userSearch) {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/users/additionaldetails`, JSON.stringify(userSearch))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getValidRolesToManage() {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/users/rolestomanage`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getUserProfile(userId) {
  return axiosInstance.get(`/user/${userId}/profile/`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}
function getSharedUserProfile(userId) {
  return axiosInstance.get(`/shareduser/${userId}/profile/`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function addUser(userData) {
  return axiosInstance.post('/users/add', JSON.stringify(userData))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function checkSharedUserByEmail(email) {
  return axiosInstance.get(`/user/${email}/email`)
    .then(response => {
      return response.data.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function changePassword(currentPassword, newPassword, userId) {
  return axiosInstance.post('/users/changepwd', JSON.stringify({
    currentPassword: currentPassword,
    newPassword: newPassword,
    id: userId
  }))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getById(id) {
  return axiosInstance.get(`/user/${id}`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function addSharedUser(userData) {
  return axiosInstance.post(`/user/${userData.additionalInfo.member_guid}/addshareduser`, JSON.stringify(userData))
    .then(response => {
      return response.data.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

/**
 *
 * @param memberGuid
 * @return {Promise<{statusCode: int, data: {sharedUsers: SharedUser[]}}>}
 */
function getAllSharedUsers(memberGuid) {
  return axiosInstance.get(`/user/${memberGuid}/sharedusers`)
    .then(response => {
      return {...response.data, data: {...response.data.data, sharedUsers: SharedUser.translateObjectArray(response.data.data.sharedUsers)}};
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

/**
 *
 * @param memberGuid
 * @param documentGuid
 * @return {Promise<{statusCode: int, data: {sharedUsers: SharedUser[]}}>}
 */
function getAllSharedUsersOfDocument(memberGuid, documentGuid) {
  return axiosInstance.get(`/user/${memberGuid}/${documentGuid}/sharedusers`)
    .then(response => {
      return {...response, data: {...response.data.data, sharedUsers: SharedUser.translateObjectArray(response.data.data.sharedUsers)}}
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

/**
 *
 * @param sharedUsers {SharedUser|SharedUser[]}
 * @param memberGuid
 * @return {Promise<{statusCode: int, data: SharedUser[]}>}
 */
function removeSharedUsers(sharedUsers, memberGuid){
  return axiosInstance.post(`/user/${memberGuid}/removeshareduser`, JSON.stringify(sharedUsers))
    .then(response => {
      return {...response.data, data: SharedUser.translateObjectArray(response.data.data)};
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    })
}

/**
 *
 * @param sharedUsers {SharedUser|SharedUser[]}
 * @param memberGuid
 * @param documentId
 * @return {Promise<{statusCode: int, data: SharedUser[]}>}
 */
function removeSharedUsersOfDocument(sharedUsers, memberGuid, documentId){
  return axiosInstance.post(`/user/${memberGuid}/${documentId}/removeshareduser`, JSON.stringify(sharedUsers))
    .then(response => {
      return {...response.data, data: SharedUser.translateObjectArray(response.data.data)};
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    })
}

/**
 * @param sharedUserId
 * @param memberGuid
 * @param companyId
 * @return boolean
 */
function removeSharedUserAndDocuments(sharedUserId, memberGuid, companyId){
  return axiosInstance.post(`/user/${memberGuid}/removeshareduseranddocuments`, {"sharedUserId": sharedUserId, "companyId": companyId})
    .then(response => {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    })
}

function register(user) {
  return axiosInstance.post('/users/register', JSON.stringify(user))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function sendEmailToUser(emailDetails) {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/users/sendemail`, {"emailDetails": emailDetails})
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function updateUserDetails(userData) {
  return axiosInstance.post('/users/updatedetails', JSON.stringify(userData))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function updateUserProfile(profile) {
  console.log(profile);
  return axiosInstance.post(`/user/${profile.id}/updateprofile`, JSON.stringify(profile))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function updateSharedUserDetails(userData) {
  return axiosInstance.post(`/user/${userData.keyInfo.memberGuid}/updateshareduser`, JSON.stringify(userData))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function updateSharedUserKeyInfo(userData) {
  return axiosInstance.post(`/user/${userData.memberGuid}/updateshareduserkey`, JSON.stringify(userData))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function updateSharedUserPasswordInfo(userData) {
  return axiosInstance.post(`/user/${userData.memberGuid}/updateshareduserexpiration`, JSON.stringify(userData))
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function deactivateUserById(id) {
  return axiosInstance.get(`/user/${id}/deactivate`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function activateUserById(id) {
  return axiosInstance.get(`/user/${id}/activate`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function lockUserById(id) {
  return axiosInstance.get(`/user/${id}/lock`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function unlockUserById(id) {
  return axiosInstance.get(`/user/${id}/unlock`)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function authErrorFunction(error, isOauth=true, isLogout=false) {
  const errorMessage = error.toString();

  if (errorMessage.includes('401'))
    return Promise.reject(requestHelper.handleErrorResponse({message: "Unauthorized", oauth: isOauth}));

  if (errorMessage.includes('403'))
    return Promise.reject(requestHelper.handleErrorResponse({message: "Forbidden", oauth: isOauth}))

  if (errorMessage.includes('502') || errorMessage.includes('404'))
    return Promise.reject(requestHelper.handleErrorResponse({message: `Cannot Log ${(isLogout ? "Out" : "In")} At This Time`, oauth: isOauth}));

  return Promise.reject(requestHelper.handleErrorResponse({message: "Unexpected Error", oauth: isOauth}));
}

